import {
  createTableColumn,
  TableCellLayout,
  TableColumnDefinition,
  Text,
} from "@fluentui/react-components";
import { INormBolzen } from "../../../Models/INormBolzen";

import { getHighlightedText } from "../../../Controls/HighlightedText";

export const getBolzenColumns = (
  searchString: string,
): TableColumnDefinition<INormBolzen>[] => {
  const columns = [
    createTableColumn<INormBolzen>({
      columnId: "norm",
      compare: (a, b) => {
        if (a.norm && b.norm) {
          return a.norm.localeCompare(b.norm);
        } else return 0;
      },
      renderHeaderCell: () => "Norm",
      renderCell: (item) => (
        <TableCellLayout>
          <Text> {getHighlightedText(item.norm, searchString)}</Text>
        </TableCellLayout>
      ),
    }),
    createTableColumn<INormBolzen>({
      columnId: "code",
      compare: (a, b) => {
        if (a.code && b.code) {
          return a.code.localeCompare(b.code);
        } else return 0;
      },
      renderHeaderCell: () => "Code",
      renderCell: (item) => <TableCellLayout>{item.code}</TableCellLayout>,
    }),
    createTableColumn<INormBolzen>({
      columnId: "schluesselweite",
      compare: (a, b) => {
        if (a.schluesselweite && b.schluesselweite) {
          return (a.schluesselweite ?? 0) - (b.schluesselweite ?? 0);
        } else return 0;
      },
      renderHeaderCell: () => "Schlüsselweite",
      renderCell: (item) => (
        <TableCellLayout>{item.schluesselweite}</TableCellLayout>
      ),
    }),
    createTableColumn<INormBolzen>({
      columnId: "norm_EN",
      compare: (a, b) => {
        if (a.norm_EN && b.norm_EN) {
          return a.norm_EN.localeCompare(b.norm_EN);
        } else return 0;
      },
      renderHeaderCell: () => "Norm EN",
      renderCell: (item) => <TableCellLayout>{item.norm_EN}</TableCellLayout>,
    }),
    createTableColumn<INormBolzen>({
      columnId: "version_Nr",
      compare: (a, b) => {
        if (a.version_Nr && b.version_Nr) {
          return a.version_Nr.localeCompare(b.version_Nr);
        } else return 0;
      },
      renderHeaderCell: () => "Versions-Nr.",
      renderCell: (item) => (
        <TableCellLayout>{item.version_Nr}</TableCellLayout>
      ),
    }),
    createTableColumn<INormBolzen>({
      columnId: "version_Datum",
      compare: (a, b) => {
        if (a.version_Datum && b.version_Datum) {
          return (
            new Date(a.version_Datum ?? 0).getTime() -
            new Date(b.version_Datum ?? 0).getTime()
          );
        } else return 0;
      },
      renderHeaderCell: () => "Versions-Datum",
      renderCell: (item) => (
        <TableCellLayout>
          {item.version_Datum
            ? new Date(item.version_Datum).toLocaleDateString()
            : ""}
        </TableCellLayout>
      ),
    }),
  ];

  return columns;
};
